import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class Aiden extends Component {
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    window.addEventListener('aiden-actions', (event) => {
      if (event.detail.actionId === 'aiden-add-to-cart') {
        event.detail.acknowledgeCallback();

        this.notify(Notifications.CART_ADD_ITEM, {
          sku: event.detail.products[0].id,
          amount: 1,
          openNotification: true,
          subscriptionPeriod: null,
          location: 'aiden-advice-tool',
          shouldDispatchDataLayer: true
        });
        event.detail.successCallback();
        event.detail.hideApp();
      }
    });
  }
}
